export const constantStrings = {
    defaultCountryName: 'United States',
    defaultLanguage: 'en',
    setTimeOut: 5000,
    surgeonGroup: 'surgeon',
    NEXT_UPLOAD_ID: 'nextUpload', //Constant to store Next Upload path Id
    NEW_UPLOAD_ID: 'newUpload',//Constant to store New Upload path Id
    DATE_FORMAT: 'MMM DD,YYYY', //Constant for date format
    DATE_FORMAT_YEAR: 'YYYY', //constant for date format year
    DATE_FORMAT_MONTH: 'MMMM', //constant for date format month
    SITE: 'site',
    APPLICATION: 'application',
    STATUS: 'status',
    setExpiryTime: 900,
    cardsCount: 9,
    SUCCESS: 'success',
    UNSUCCESS: 'unsuccess',
    DATE: 'date',
    STARTDATE: 'startDate',
    ENDDATE: 'endDate',
    STARTDATEDUE: 'startDateDue',
    ENDDATEDUE: 'endDateDue',
    FACILITYIMAGING: 'Imaging',
    PROCESSING: 'Uploading',
    FAILED: 'Failed',
    UPLOADED: 'Uploaded',
    ERROR: 'ERROR',
    UPLOADFILE: 'uploadFile',
    UPLOADSTATUS: 'uploadStatus',
    ALLSKIPPED: 'allFilesSkipped',
    TECHNICALERROR: 'technicalError',
    APIHANDLEERROR: 'There was technical issue. Please try again later.',
    ANATOMY: 'anatomy',
    TYPES: 'type',
    COMPLETEDDATE: 'completeddate',
    DUEDATE: 'duedate',
    anatomyGroup: 'anatomy',
    ASSIGNED: 'assigned',
    IMAGECENTER: 'imagecenter',
    AUDITLOGEXPORT: ' Audit log',
    AUDITLOGDATEEXPORT:'Auditlog_',
    NOT_APPLICABLE: 'NA',
    PageLimit: 25,
    startTimeDue: '01/01/1900 00:00:00',
    HashFailedMessage:"Integrity check verification failure on case files",
    SEARCH: 'search',
    FILTER: 'filter',
    VIEW: 'view',
    AUDITEXPORT: 'auditLogExport'
    
}

//Side menu access roles names
export const ROLE = {
    IC_ADMIN: 'ic-admin',
    IC_USER: 'ic-user',
    NURSE: 'Nurse',
    SURGEON: 'Surgeon',
    H_ADMIN: 'h-admin',
    SNN_HIL_MANAGER: 'snn-hil-manager',
    SNN_HIL_REVIEWER: 'snn-hil-reviewer',
    SNN_CLOUD_SUPPORT: 'snn-cloud-support',
    STAFF: 'staff',
}

//Side menu access positions names
export const POSITION = {
    IC_ADMIN: 'Imaging Center Admin',
    IC_USER: 'Imaging Center Technician',
    NURSE: 'Nurse',
    SURGEON: 'Surgeon',
    H_ADMIN: 'Hospital Admin',
    SNN_HIL_MANAGER: 'SNN HIL Manager',
    SNN_HIL_REVIEWER: 'SNN HIL Reviewer',
    SNN_CLOUD_SUPPORT: 'SNN Cloud Support',
    STAFF: 'Support Staff'
}

export const DICOMTAGS = {
    STUDYDATE: 'x00080020',
    SERIESDATE: 'x00080021',
    PATIENTNAME: 'x00100010',
    PATIENTBIRTHDATE: 'x00100030',
    PATIENTID: 'x00100020',
    PATIENTSEX: 'x00100040',
    PATIENTADDRESS: 'x00101040'
}
//HIL status string
export const STATUSCODESTRING = {
    statusRejected: 'REJECTED',
    statusInProgress: 'IN PROGRESS',
    statusNewUnclaimed: 'HIL_READY',
    statusError: 'ERROR',
    statusInReview: 'INREVIEW',
    statusOverdue: 'OVERDUE',
    statusApproved: 'APPROVED',
    statusNew: 'NEW',
    statusUnclaimed: 'UNCLAIMED',
    statusOverdueUnclaimed: 'OVERDUE / UNCLAIMED',
    statusOverdueNewUnclaimed:'OVERDUE / NEW',
    statusBoneModel: 'BONE_MODEL_INITIATED',
    statusProcessing: 'PROCESSING',
    statusUploadedToMic: 'UPLOADED_TO_MIC',
    statusOnTablet: 'ON_TABLET',
    statusCaseComplete: 'CASE_COMPLETE',
    statusCaseFailed: 'FAILED',
    statusUploadPending: 'UPLOAD_PENDING',
    statusCaseCancel: 'CASE_CANCEL'
}
//HIL status code 
export const statusCode = {    
    APPROVED: 10,
    REJECTED: 11,
    INREVIEW: 9,
    UNCLAIMED: 14,
    NEW: 15, 
    BONE_MODEL_INITIATED: 16,
    ERROR: 4,
    UPLOADED_TO_MIC: 17,
    ON_TABLET: 18,
    CASE_COMPLETE: 19,
    FAILED: 21,
    UPLOAD_PENDING: 22,
    CASE_CANCEL: 23
}
//API Names 
export const APINames = {
    CaseDB : "CaseDB",
    CaseDetails : "CaseDetails",
    Facility : "Facility",
    Export : "Export",
    LOGIN : "Login",
    FilterValue: "FilterValue",
    EditDueDate : "EditDueDate"
}
//Case DB component names
export const CompName ={
    ACTIVE : "ACTIVECASE",
    CASEHISTORY: "CASEHISTORY",
    MYCASES: "MYCASES",
    SETTINGS: "SETTINGS"
}
//types of Events
export const EventType = {
    create: "CREATE",
    read: "READ",
    update: "UPDATE",
    delete: "DELETE"
}
//API errors
export const APIError ={
    NoAuditLogs: "No audit log available. If you think this is an error please contact your manager",
    processingErr: "Processing error. Please refresh your browser and try again. If the problem persists please contact your manager"
}

export const HashFailure = {
    HashFailedMessage:"Integrity check verification failure on case files"
}